<template>
  <div class="d-flex-column justify-start align-start gap-12">
    <PackTiming
      v-if="gameStore.getGamePack?.pack_slots && !$isMobile() && !$isTablet()"
    />
    <PackDetail2 />
  </div>

  <div class="pack_text_detail" v-html="text"></div>
</template>

<script setup>
import PackDetail2 from "./pickers/PackDetail2.vue";
import PackTiming from "~/components/common/PackTiming.vue";
const { currentGamePackSlug } = useGameComposable();
const gameStore = useGameStore();
const { t } = useI18n();
const text = computed(() => {
  return t(`fc-boost.details.${currentGamePackSlug}`);
});
</script>

<style lang="scss">
@import "../../../assets/scss/fonts.scss";
.pack_text_detail {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 18px;
  h1 {
    @extend .font-family-2;
    @extend .bold-xxl;
    @extend .t-white;
  }
  p {
    @extend .font-family-2;
    @extend .regular-l;
    @extend .t-light;
  }

  ul {
    @extend .font-family-2;
    @extend .regular-l;
    @extend .t-light;
    padding-left: 16px;
    li {
      &:not(:last-child) {
        margin-bottom: 3px;
      }
    }
  }
}
</style>
